import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const ArrowIcon: FC<SvgProps> = (props) => {
    return (
        <Svg width="16" height="16" fill="none" {...props}>
            <Path
                fill={ColorEnum.GRAY_900}
                d="M8.233 3.159c.167.166.253.35.258.55.006.2-.075.383-.242.55L5.3 7.208h6.984c.211 0 .397.08.558.241a.767.767 0 0 1 0 1.117.767.767 0 0 1-.558.242H5.3l2.95 2.933a.74.74 0 0 1 .241.559.803.803 0 0 1-.258.557.791.791 0 0 1-.55.234.791.791 0 0 1-.55-.234L2.849 8.575a.685.685 0 0 1-.19-.266.82.82 0 0 1-.06-.3c0-.1.02-.198.06-.292a.852.852 0 0 1 .19-.275L7.133 3.16c.167-.167.35-.248.55-.242.2.005.383.086.55.242Z"
            />
        </Svg>
    )
}

export default ArrowIcon
